export const MAX_ENTRIES_FOR_EDIT = 100
